module.exports = __webpack_public_path__ + "media/newstyle/images/img2-footer-aus-b8ed2ef17ef268d519d9061c3d9106f9.svg";